import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "animated fadeIn" }
const _hoisted_2 = { class: "text-subtitle1" }
const _hoisted_3 = { class: "text-center q-my-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_details_step = _resolveComponent("details-step")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_assign_step = _resolveComponent("assign-step")!
  const _component_confirm_step = _resolveComponent("confirm-step")!
  const _component_payment_step = _resolveComponent("payment-step")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    persistent: "",
    ref: "modal"
  }, _createSlots({
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_stepper, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step) = $event)),
        color: "primary",
        "done-color": "positive",
        animated: "",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_step, {
            name: 1,
            title: "Details",
            done: _ctx.detailsStepDone
          }, {
            default: _withCtx(() => [
              _createVNode(_component_details_step, {
                "first-name": _ctx.firstName,
                "onUpdate:firstName": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                "last-name": _ctx.lastName,
                "onUpdate:lastName": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                email: _ctx.email,
                "onUpdate:email": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                phone: _ctx.phone,
                "onUpdate:phone": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event)),
                "date-of-birth": _ctx.dateOfBirth,
                "onUpdate:dateOfBirth": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
                "file-ref-no": _ctx.fileRefNo,
                "onUpdate:fileRefNo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fileRefNo) = $event)),
                "date-of-loss": _ctx.dateOfLoss,
                "onUpdate:dateOfLoss": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateOfLoss) = $event)),
                onDone: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailsStepDone = $event))
              }, null, 8, ["first-name", "last-name", "email", "phone", "date-of-birth", "file-ref-no", "date-of-loss"])
            ]),
            _: 1
          }, 8, ["done"]),
          _createVNode(_component_q_step, {
            name: 2,
            title: "Assign",
            done: _ctx.step > 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_assign_step, {
                "account-id": _ctx.customerId,
                modelValue: _ctx.assignTo,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.assignTo) = $event))
              }, null, 8, ["account-id", "modelValue"])
            ]),
            _: 1
          }, 8, ["done"]),
          _createVNode(_component_q_step, {
            name: 3,
            title: "Confirm",
            done: _ctx.step > 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_confirm_step, {
                "first-name": _ctx.firstName,
                "last-name": _ctx.lastName,
                email: _ctx.email,
                phone: _ctx.phone,
                "date-of-birth": _ctx.dateOfBirth,
                "file-ref-no": _ctx.fileRefNo,
                "date-of-loss": _ctx.dateOfLoss
              }, null, 8, ["first-name", "last-name", "email", "phone", "date-of-birth", "file-ref-no", "date-of-loss"])
            ]),
            _: 1
          }, 8, ["done"]),
          _createVNode(_component_q_step, {
            name: 4,
            title: "Payment",
            done: _ctx.paymentStepDone
          }, {
            default: _withCtx(() => [
              _createVNode(_component_payment_step, {
                "customer-id": _ctx.customerId,
                modelValue: _ctx.paymentMethodId,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.paymentMethodId) = $event)),
                onDone: _cache[10] || (_cache[10] = ($event: any) => (_ctx.paymentStepDone = $event))
              }, null, 8, ["customer-id", "modelValue"])
            ]),
            _: 1
          }, 8, ["done"])
        ]),
        _: 1
      }, 8, ["modelValue"]), [
        [_vShow, !_ctx.isAdded]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.lastName) + ", " + _toDisplayString(_ctx.firstName) + " has been successfully added and has been sent an email asking them to connect their active social media accounts. ", 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            label: "Add Another Client",
            color: "primary",
            onClick: _ctx.addAnother
          }, null, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.isAdded]
      ])
    ]),
    _: 2
  }, [
    (!_ctx.isAdded)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_btn, {
              label: "Prev",
              onClick: _ctx.prev
            }, null, 8, ["onClick"]), [
              [_vShow, _ctx.step > 1]
            ]),
            _withDirectives(_createVNode(_component_q_btn, {
              label: "Next",
              color: "primary",
              disable: !_ctx.canProceed,
              onClick: _ctx.next
            }, null, 8, ["disable", "onClick"]), [
              [_vShow, _ctx.step < 4]
            ]),
            _withDirectives(_createVNode(_component_async_btn, {
              label: "Add Client",
              color: "primary",
              task: _ctx.task,
              disable: !_ctx.canAdd,
              onClick: _ctx.add
            }, null, 8, ["task", "disable", "onClick"]), [
              [_vShow, _ctx.step === 4]
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title"]))
}